import apiClient from "@/src/services/api/axios";
import { useMutation } from "@tanstack/react-query";

type UploadFileInput = {
  uri: string;
  fileName?: string;
  mimeType?: string;
  moduleName?: number;
};

const getPresignedUrl = async (fileName: string) => {
  const response = await apiClient.post(
    "/data/v4/Files/GetPreSignedUrlForUpload",
    {
      name: fileName,
      projectKey: process.env.EXPO_PUBLIC_X_BLOCKS_KEY,
      configurationName: "Default",
      accessModifier: "Public",
      metaData: "",
      parentDirectoryId: process.env.EXPO_PUBLIC_PARENT_DIRECTORY_ID,
      tags: "",
      moduleName: 3,
    },
  );
  return response.data;
};

const uploadToBlob = async (
  uploadUrl: string,
  uri: string,
  mimeType?: string,
) => {
  const response = await fetch(uri);
  const blob = await response.blob();
  await fetch(uploadUrl, {
    method: "PUT",
    body: blob,
    headers: {
      "Content-Type": mimeType ?? "",
      "x-ms-blob-type": "Blockblob",
    },
  });
};

// NOTE: there is deliberately no `/Files/UploadFile` step. In v4 the upload IS
// presign + PUT straight to the storage provider — the v1 `uploadMetadata` call
// that used to live here was already dead (its only call site was commented out)
// and the platform docs are explicit that it must not be called.

export const useUploadFile = () => {
  return useMutation({
    mutationFn: async ({ uri, fileName, mimeType }: UploadFileInput) => {
      const resolvedFileName = fileName ?? `upload_${Date.now()}`;
      const { uploadUrl } = await getPresignedUrl(resolvedFileName);
      await uploadToBlob(uploadUrl, uri, mimeType);
      return uploadUrl.split("?")[0];
    },
  });
};
